"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var jss_1 = require("jss");
var JssProvider_1 = __importDefault(require("react-jss/lib/JssProvider"));
var styles_1 = require("@material-ui/core/styles");
var getMaterialTheme_1 = require("../../../javascripts/getMaterialTheme");
var styled_components_1 = require("styled-components");
var theme_1 = require("../styles/theme");
var selectors_1 = require("../common/selectors");
function default_1(props) {
    var materialUI = props.materialUI;
    var onPlatform = (0, react_redux_1.useSelector)(selectors_1.onPlatformSelector);
    var theme = (0, getMaterialTheme_1.getMuiTheme)(onPlatform);
    // Create a new class name generator.
    var generateClassName = (0, styles_1.createGenerateClassName)({
        productionPrefix: "".concat(materialUI, "-react-app"),
    });
    var jss = (0, jss_1.create)(__assign(__assign({}, (0, styles_1.jssPreset)()), { 
        // We define a custom insertion point that JSS will look for injecting the styles in the DOM.
        insertionPoint: typeof document !== 'undefined' &&
            document.getElementById('jss-insertion-point') }));
    return (react_1.default.createElement(JssProvider_1.default, { jss: jss, generateClassName: generateClassName },
        react_1.default.createElement(styled_components_1.ThemeProvider, { theme: theme_1.theme },
            react_1.default.createElement(styles_1.MuiThemeProvider, { theme: theme }, props.children))));
}
exports.default = default_1;
